// One physical hand, never a hidden stock or a selected inventory slot.
export function resolveUse({state,hit=null,caseHit=null,placement=null,reachable=()=>false}){
 const handling=['collect','practice','fasten'].includes(state.stage),item=handling?state.held:null;
 if(item&&caseHit&&reachable(caseHit)&&(!hit||caseHit.distance<hit.distance-1e-5||hit.object?.userData?.id==='toolbox'))return {kind:'return',item,hit:caseHit};
 if(hit&&reachable(hit)){
  const id=hit.object?.userData?.id??'';
  if(item&&(id.startsWith('item:')||id.startsWith('drop:')))return {kind:'blocked',item,hit};
  return {kind:'target',hit};
 }
 if(item&&placement&&['x','y','z'].every(k=>Number.isFinite(placement[k]))&&placement.y>=0&&reachable({point:placement}))return {kind:'place',item,point:placement};
 return {kind:'none'};
}
